import {
  Sheet,
  SheetHeader,
  SheetTitle,
  SheetDescription,
  SheetContent,
} from '@/components/ui/sheet';
import CalendarBookingForm from '@/components/elements/forms/calendarBookingForm';
import { DateSelectArg } from '@fullcalendar/core/index.js';
import { UserContext } from '@/contexts/UserContext';
import { useContext } from 'react';

interface AddCalendarBookingProps {
  dateSelected?: DateSelectArg;
  show: boolean;
  setShow: (open: boolean) => void;
}

export default function AddCalendarBooking({
  ...props
}: AddCalendarBookingProps) {
  const userContext = useContext(UserContext);

  return (
    <Sheet open={props.show} onOpenChange={props.setShow}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Add Booking</SheetTitle>
          <SheetDescription>Provide the booking details below</SheetDescription>
        </SheetHeader>
        <CalendarBookingForm
          parentShow={props.setShow}
          date={props.dateSelected?.start}
          bookingStart={props.dateSelected?.start}
          bookingEnd={props.dateSelected?.end}
          userId={userContext.claims?.sub}
        />
      </SheetContent>
    </Sheet>
  );
}
